import { ProjectReviewVisitV2FinalReportRoute_GetDataQuery } from "../routes/ProjectReviewVisitV2FinalReportRoute/queries.generated";
import { ProjectReviewVisitV2OverviewRoute_GetDataQuery } from "../routes/ProjectReviewVisitV2OverviewRoute/queries.generated";

export function useReviewVisitPanelStatus(
    result:
        | undefined
        | ProjectReviewVisitV2OverviewRoute_GetDataQuery
        | ProjectReviewVisitV2FinalReportRoute_GetDataQuery,
) {
    const panelStatus = {
        time:
            result?.plannerV2VisitGetById?.timeProtocolAutoValidationOverriddenAt !== null ||
            (result?.plannerVisitHasAllTimeRangesValid ?? false),
        weather:
            result?.plannerV2VisitGetById?.weatherProtocolAutoValidationOverriddenAt !== null ||
            (result?.plannerVisitHasAllWeatherConditionsValid ?? false),
        functions: result?.plannerVisitHasAllPossibleFunctionsHandled ?? false,
        observations: result?.plannerVisitHasAllObservationsApproved ?? false,
        team: result?.plannerVisitHasAllReportsApproved ?? false,
    };

    const isEverythingReady = Object.values(panelStatus).every(value => value === true);

    return { panelStatus, isEverythingReady };
}
